// extracted by mini-css-extract-plugin
export default {"tab_panel":"Dashboard_tab_panel__eiWz3"};